const RouteNames = {
  HOME: '/',

  // Auth
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT_PASSWORD: 'forgot-password',
  PASSWORD_RESET: 'reset-password',

  // Footer
  // OFFER: 'public-offer',
  // POLICY: 'privacy-policy',

  // Acc
  MY_ACCOUNTS: 'my-accounts',
  PERSONAL_ACCOUNTS: 'personal-accounts',
  CREATE_PERSONAL_ACCOUNT: 'create-personal-account',
  TRADE_ACCOUNTS: 'trade-accounts',
  CREATE_TRADE_ACCOUNT: 'create-trade-account',
  DEMO_ACCOUNTS: 'demo-accounts',
  CREATE_DEMO_ACCOUNT: 'create-demo-account',
  ACCOUNT: ':accountId',

  PAYMENTS: 'payments',
  DEPOSIT: 'deposit',
  CREATE_DEPOSIT: 'create-deposit',
  WITHDRAWAL: 'withdrawal',
  CREATE_WITHDRAWAL: 'create-withdrawal',
  TRANSFER: 'transfer',
  CREATE_TRANSFER: 'create-transfer',
  PAYMENT_HISTORY: 'payment-history',

  PARTNERS: 'partners',
  CREATE_PARTNER_ACCOUNT: 'create-partner-account',
  STATISTIC: 'statistic',
  PROGRAM_DETAILS: 'program-details',
  UTM: ':partnerLogin/:utmId',
  TRANSACTIONS: 'transactions',
  COMMISSIONS: 'commissions',
  REFERRAL: ':partnerLogin/:referralId',

  TRADING_PLATFORMS: 'trading-platforms',

  PAMM: 'pamm',

  SUPPORT: 'support',
  CREATE_TICKET: 'create-ticket',
  TICKET: 'ticket',

  NOTIFICATIONS: 'notifications',

  PROFILE: 'my-profile',
  PERSONAL_DATA: 'personal-data',
  FINANCIAL_PROFILE: 'financial-profile',
  DOCUMENTS: 'documents',
  SETTINGS: 'settings',

  ANY: '*',
};

export default RouteNames;
